import { Button, Drawer, Form, Input, Select, Space } from "antd";
import { useContext, useEffect, useState } from "react";
import { IBaseDrawerModel } from "../../../Types";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import OrganisationsService, {
  Department_Type,
  DepartmentTypeList,
  IDepttData,
  IDepttRequestModel,
  IDesignationData,
  IDesignationRequestModel,
  IEmpRequestModel,
  IOrganiseData,
  ISubUnitData,
} from "../../Services/Organisations/OrganisationsService";
import { IApiResponse } from "../../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "../../Services/ItemsService";
import { IDropdownProps } from "../Settings/SettingVoucherTemplate";

const AddEmpModel = ({
  isModalOpen,
  setIsModalOpen,
  id,
  setTrigger,
}: IBaseDrawerModel) => {
  const [form] = Form.useForm<IEmpRequestModel>();
  const { currentClient } = useClient();
  const [loading, setLoading] = useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const [orgList, setOrgList] = useState<IOrganiseData[]>([]);
  const [subUnitList, setSubUnitList] = useState<ISubUnitData[]>([]);
  const [depttList, setDepttList] = useState<IDepttData[]>([]);
  const [designationList, setDesignationList] = useState<IDesignationData[]>(
    []
  );
  const [selOrg, setSelOrg] = useState<string>("");
  const [selSubUnit, setSelSubUnit] = useState<string>("");
  const [selDeptt, setSelDeptt] = useState<string>("");

  const saveData = async (formData: IEmpRequestModel) => {
    setLoading(true);
    await OrganisationsService.postEmployee(currentClient?.id!, formData, id!)
      .then((val: IApiResponse<IIdNameModel>) => {
        openNotification(
          "success",
          `${val?.result?.name} employee ${
            id ? "updated" : "added"
          } successfully`
        );
        setIsModalOpen({
          open: false,
          id: "",
        });
        setLoading(false);
        setTrigger && setTrigger((prev) => !prev);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };

  const submitForm = (val: IEmpRequestModel) => {
    saveData(val);
  };

  const getData = async () => {
    setLoading(true);
    await OrganisationsService.getEmployee(currentClient?.id!, id!)
      .then((val: IEmpRequestModel | null) => {
        setSelOrg(val?.orgId as string);
        setSelSubUnit(val?.subUnitId as string);
        setSelDeptt(val?.depttId as string);
        let formValues: IEmpRequestModel = {
          empName: val?.empName as string,
          empCode: val?.empCode as string,
          fatherName: val?.fatherName as string,
          email: val?.email as string,
          createLoginCredential: val?.createLoginCredential as boolean,
          seniorEmpId: val?.seniorEmpId as string,
          orgId: val?.orgId as string,
          subUnitId: val?.subUnitId as string,
          depttId: val?.depttId as string,
          designationId: val?.designationId as string,
        };
        form.setFieldsValue(formValues);
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (id) getData();
  }, [id]);

  const getOrgList = async () => {
    setLoading(true);
    await OrganisationsService.getOrganisationsList(currentClient?.id!)
      .then((val: IOrganiseData[] | null) => {
        setOrgList(
          val?.map((org: IOrganiseData) => ({
            id: org.id,
            orgName: org.orgName,
          })) || []
        );
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  const getSubUnitList = async () => {
    setLoading(true);
    await OrganisationsService.getSubUnitsList(currentClient?.id!)
      .then((val: ISubUnitData[] | null) => {
        setSubUnitList(
          val?.map((subUnit: ISubUnitData) => ({
            id: subUnit.id,
            orgName: subUnit.orgName,
            orgId: subUnit.orgId,
            subUnitName: subUnit.subUnitName,
          })) || []
        );
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  const getDepttList = async () => {
    setLoading(true);
    await OrganisationsService.getDepttList(currentClient?.id!)
      .then((val: IDepttData[] | null) => {
        setDepttList(
          val?.map((deptt: IDepttData) => ({
            id: deptt.id,
            depttName: deptt.depttName,
            depttType: deptt.depttType,
            orgId: deptt.orgId,
            orgName: deptt.orgName,
            subUnitId: deptt.subUnitId,
            subUnitName: deptt.subUnitName,
          })) || []
        );
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  const getDesignationList = async () => {
    setLoading(true);
    await OrganisationsService.getDesignationsList(currentClient?.id!)
      .then((val: IDesignationData[] | null) => {
        setDesignationList(
          val?.map((des: IDesignationData) => ({
            id: des.id,
            designationName: des.designationName,
            orgId: des.orgId,
            orgName: des.orgName,
            subUnitId: des.subUnitId,
            subUnitName: des.subUnitName,
            depttId: des.depttId,
            depttName: des.depttName,
          })) || []
        );
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    getOrgList();
    getSubUnitList();
    getDepttList();
    getDesignationList();
  }, [currentClient?.id]);

  return (
    <Drawer
      open={isModalOpen}
      onClose={() =>
        setIsModalOpen({
          open: false,
          id: "",
        })
      }
      title={`${id ? "Update" : "Save"} employee`}
      width={"30vw"}
      extra={
        <Space>
          <Button
            disabled={loading}
            onClick={() => {
              form.resetFields();
              setIsModalOpen({
                open: false,
                id: "",
              });
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            loading={loading}
            type="primary"
            onClick={() => {
              form.validateFields().then(submitForm);
            }}
          >
            {`${id ? "Update" : "Save"}`}
          </Button>
        </Space>
      }
    >
      <Form name="employee" form={form} disabled={loading} layout="vertical">
        <Form.Item
          name="empName"
          label="Empoyee's Name"
          rules={[
            { required: true },
            {
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]{2,49}$/,
              message: "Value's length must be between 3 and 50",
            },
          ]}
        >
          <Input
            type="text"
            maxLength={50}
            minLength={3}
            placeholder="Enter name here..."
          ></Input>
        </Form.Item>
        <Form.Item
          name="fatherName"
          label="Empoyee Father's Name"
          rules={[
            { required: true },
            {
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]{2,49}$/,
              message: "Value's length must be between 3 and 50",
            },
          ]}
        >
          <Input
            type="text"
            maxLength={50}
            minLength={3}
            placeholder="Enter name here..."
          ></Input>
        </Form.Item>
        <Form.Item
          name="empCode"
          label="Empoyee's Code"
          rules={[
            { required: true },
            {
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]{1,19}$/,
              message: "Value's length must be between 2 and 20",
            },
          ]}
        >
          <Input
            type="text"
            maxLength={50}
            minLength={3}
            placeholder="Enter name here..."
          ></Input>
        </Form.Item>

        <Form.Item
          name="orgId"
          label="Organisation"
          rules={[{ required: true, message: "Please select organisation" }]}
        >
          <Select
            placeholder="Select organisation"
            onSelect={(val: string) => {
              form.setFieldValue("subUnitId", undefined);
              form.setFieldValue("depttId", undefined);
              setSelOrg(val);
              setSelSubUnit("");
            }}
            options={orgList.map((org: IOrganiseData) => ({
              label: org.orgName,
              value: org.id,
              key: org.id,
              title: "",
            }))}
          ></Select>
        </Form.Item>
        <Form.Item
          name="subUnitId"
          label="Sub Unit"
          rules={[{ required: true, message: "Please select sub unit" }]}
        >
          <Select
            disabled={selOrg === ""}
            placeholder="Select sub unit"
            onSelect={(val: string) => {
              form.setFieldValue("depttId", undefined);
              setSelSubUnit(val);
            }}
            options={subUnitList
              .filter((subUnit: ISubUnitData) => subUnit.orgId === selOrg)
              .map((subUnit: ISubUnitData) => ({
                label: subUnit.subUnitName,
                value: subUnit.id,
                key: subUnit.id,
                title: "",
              }))}
          ></Select>
        </Form.Item>
        <Form.Item
          name="depttId"
          label="Department"
          rules={[{ required: true, message: "Please select department" }]}
        >
          <Select
            disabled={selSubUnit === ""}
            placeholder="Select department"
            onSelect={(val: string) => {
              form.setFieldValue("designationId", undefined);
              setSelDeptt(val);
            }}
            options={depttList
              .filter((deptt: IDepttData) => deptt.subUnitId === selSubUnit)
              .map((deptt: IDepttData) => ({
                label: deptt.depttName,
                value: deptt.id,
                key: deptt.id,
                title: "",
              }))}
          ></Select>
        </Form.Item>
        <Form.Item
          name="designationId"
          label="Designation"
          rules={[{ required: true, message: "Please select designation" }]}
        >
          <Select
            disabled={selDeptt === ""}
            placeholder="Select designation"
            options={designationList
              .filter((des: IDesignationData) => des.depttId === selDeptt)
              .map((des: IDesignationData) => ({
                label: des.designationName,
                value: des.id,
                key: des.id,
                title: "",
              }))}
          ></Select>
        </Form.Item>
        {/* <Form.Item
          name="seniorEmpId"
          label="Senior Employee"
          // rules={[{ required: true, message: "Please select senior employee" }]}
        >
          <Select
            placeholder="Select senior employee"
            options={designationList
              .filter((des: IDesignationData) => des.depttId === selDeptt)
              .map((des: IDesignationData) => ({
                label: des.designationName,
                value: des.id,
                key: des.id,
                title: "",
              }))}
          ></Select>
        </Form.Item> */}
      </Form>
    </Drawer>
  );
};

export default AddEmpModel;
